import { ReactNode } from "react"

interface ContentSectionProps {
  children: ReactNode
  title?: string
  description?: string
  id?: string
  className?: string
  background?: "default" | "muted" | "primary"
}

export function ContentSection({
  children,
  title,
  description,
  id,
  className = "",
  background = "default"
}: ContentSectionProps) {
  const bgClass = {
    default: "",
    muted: "bg-muted/30",
    primary: "bg-primary/5"
  }[background]

  return (
    <section id={id} className={`py-16 sm:py-24 ${bgClass} ${className}`}>
      <div className="container px-6">
        {(title || description) && (
          <div className="mb-12">
            {title && (
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-4 text-lg text-muted-foreground max-w-3xl">
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  )
}
